module.exports = __webpack_public_path__ + "img/coround@2x.e153062.webp";